export class FiltrosDnxSubastar{
    
    Estado : string = "V";
    
}